<template>
  <div>
    <div class="px-5 lg:px-0  lg:mt-0">
      <p class="font-display text-2xl font-bold mb-4 text-gray-900">{{ $t('competitions') }}</p>
      <div class="flex flex-col gap-3 lg:flex-row lg:items-center justify-start lg:justify-between lg:px-0">
        <div class="flex flex-col lg:flex-row gap-3 justify-start lg:items-center">
          <div class="flex justify-between">
            <button @click="$router.back()"
              class="font-body text-base text-white flex items-center gap-1 bg-blue rounded-full px-3 py-1 w-fit">
              <img src="../../../assets/img/back-arrow.svg" class="h-3 w-4 inline"> {{ $t('back').tTitle() }}
            </button>
            <div class="relative flex gap-x-3">
              <!-- Prizes only for mobile -->
              <div @click="togglePrizeDropdown(true)" ref="dropdownMobile"
                class="lg:hidden flex items-center border border-gray-900 px-4 rounded-full cursor-pointer">
                <span class="text-base text-gray-900 font-medium">
                  {{ $t('view_prizes') }}
                </span>
                <!-- Dropdown Menu -->
                <transition name="fade">
                  <div v-show="openPrizesMobile"
                    class="absolute right-0 top-8 z-10 mt-2 py-3 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu">
                    <div class="pb-2 border-b border-b-gray-300 px-4" role="none">
                      <h3 class="text-blue text-xl font-semibold">{{ $t('prizes') }}</h3>
                    </div>
                    <div v-for="prize in prizes" :key="prize.title" class="px-4 flex flex-col gap-y-3 mt-3">
                      <div class="flex justify-between items-center">
                        <div class="flex gap-x-3 items-center">
                          <img :src="prize.icon" width="35" height="35" alt="3000">
                          <h3 class="text-base font-semibold" :class="'text-' + prize.color">${{ prize.amount }}</h3>
                        </div>
                        <p class="text-xs text-gray-600">{{ prize.title }}</p>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <!-- Rules only for mobile -->
              <div @click="openRules = true"
                class="lg:hidden flex items-center border border-gray-900 px-4 rounded-full cursor-pointer">
                <span class="text-base text-gray-900 font-medium">
                  {{ $t('rules') }}
                </span>
              </div>
            </div>
          </div>
          <h3 class="text-blue text-xl font-medium">{{ competition.name }}</h3>
        </div>
        <div class="relative flex gap-x-3 mr-5">
          <!-- Prizes only for desktop -->
          <div @click="togglePrizeDropdown(false)" ref="dropdown"
            class="hidden lg:flex items-center border border-gray-900 px-4 rounded-full cursor-pointer">
            <span class="text-base text-gray-900 font-medium">
              {{ $t('view_prizes') }}
            </span>
            <!-- Dropdown Menu -->
            <transition name="fade">
              <div v-show="openPrizes"
                class="absolute right-0 top-8 z-10 mt-2 w-56 origin-top-right py-3 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu">
                <div class="pb-2 border-b border-b-gray-300 px-4" role="none">
                  <h3 class="text-blue text-xl font-semibold">{{ $t('prizes') }}</h3>
                </div>
                <div v-for="(prize, i) in prizes" :key="i" class="px-4 flex flex-col gap-y-3 mt-3">
                  <div class="flex justify-between items-center">
                    <div class="flex gap-x-3 items-center">
                      <img :src="prize.icon" width="35" height="35" alt="3000">
                      <h3 class="text-base font-semibold" :class="'text-' + prize.color">${{ prize.amount }}</h3>
                    </div>
                    <p class="text-xs text-gray-600">{{ prize.title }}</p>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!-- Rules only for desktop -->
          <div @click="openRules = true"
            class="hidden lg:block border border-gray-900 px-4 rounded-full cursor-pointer">
            <span class="text-base text-gray-900 font-medium">
              {{ $t('rules') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-3 md:mx-0 bg-white px-4 py-4 rounded-lg mt-8">
      <div
        class="inline-grid grid-cols-1 grid-rows-4 gap-2 md:grid-rows-2 md:grid-cols-2 xl:grid-cols-4 xl:grid-rows-1 w-full">
        <StatisticsCards v-for="statistic in statisticsCards" :key="statistic.id" :item="statistic" :large="true"
          mode="secondary" />
      </div>
    </div>
    <LeaderboardMobile v-if="isMobile" :contestants="contestants" @nameChange="nameChange" @pageChange="pageChange"
      @selectContestant="selectContestant" :userIsContestant="userIsContestant" :page="page"
      :currentUserData="currentUserData" :selectedContestant="selectedContestant" :records=records />
    <LeaderboardDesktop v-else :contestants="contestants" @nameChange="nameChange" @pageChange="pageChange"
      @selectContestant="selectContestant" :userIsContestant="userIsContestant" :page="page"
      :currentUserData="currentUserData" :selectedContestant="selectedContestant" :records=records />
    <Modal :opened="openRules" :title="$t('rules')" @close="openRules = false">
      <Rules />
    </Modal>
  </div>
</template>

<script>
import Rules from '../shared-components/Rules.vue';
import StatisticsCards from '../shared-components/StatisticsCards.vue';
import Modal from '@/components/reusableComponents/Modal.vue';
import LeaderboardDesktop from './LeaderboardDesktop.vue';
import LeaderboardMobile from './LeaderboardMobile.vue';
import { service } from '@/main';
import { mapActions, mapGetters } from 'vuex';
export default {

  data() {
    return {
      competition: {},
      contestants: [],
      isMobile: window.innerWidth < 434,
      statisticsCards: [
        { id: 'remaining_time', title: "", icon: require('@/assets/img/icons/competitions/time-remaining.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '', remainingTime: '' },
        { id: 'prize_pool', title: "", icon: require('@/assets/img/icons/competitions/prize-pool.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '', remainingTime: '' },
        { id: 'nr_contestants', title: "", icon: require('@/assets/img/icons/competitions/contestants.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '', remainingTime: '' },
        { id: 'current_leader', title: "", icon: require('@/assets/img/icons/competitions/current-leader.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '', remainingTime: '' }
      ],
      prizes: [],
      openRules: false,
      openPrizes: false,
      openPrizesMobile: false,
      selectedContestant: {},
      currentUserData: {},
      userIsContestant: false,
      nameSearch: '',
      page: 1,
      records: 0
    }
  },
  components: { Rules, StatisticsCards, Modal, LeaderboardDesktop, LeaderboardMobile },

  mounted() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    if (this.$route.query.competition) {
      this.competition = JSON.parse(this.$route.query.competition)
      this.$router.replace({ 'query': null });
      this.getCurrentContestant()
      this.populateStatisticsCards()
      this.populatePrizes()
      this.getContestants()
      document.addEventListener("click", this.closeDropdown);
    } else {
      this.$router.push('/' + this.Language + '/competitions')
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
    window.removeEventListener('resize', this.updateIsMobile)
  },
  watch: {
    Language() {
      this.populateStatisticsCards()
      this.populatePrizes()
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/info',
      Language: 'language/code'
    })
  },
  methods: {
    populateStatisticsCards() {
      this.statisticsCards.map((statistic) => {
        switch (statistic.id) {
          case 'remaining_time':
            statistic.title = this.$t('remaining_time')
            statistic.remainingTime = this.competition.end_date
            break;
          case 'prize_pool':
            statistic.title = this.$t('prize_pool')
            statistic.statisticValueDate = `$${this.competition.prizes.reduce((sum,item) => sum + Number(item),0)}`
            break;
          case 'nr_contestants':
            statistic.title = this.$t('nr_contestants')
            statistic.statisticValueNumber = this.competition.contestants_count
            break;
          case 'current_leader':
            statistic.title = this.$t('current_leader')
            break;
        }
      })
    },
    populatePrizes() {
      if (this.competition.prizes) {
        let prizes = []
        this.competition.prizes.map((prize, i) => {
          let prizeObject = {
            amount: prize,
          }
          switch (i) {
            case 0:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize1.svg`),
                prizeObject.title = this.$t('first_place')
              prizeObject.color = 'green'
              break
            case 1:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize2.svg`),
                prizeObject.title = this.$t('second_place')
              prizeObject.color = 'blue'
              break
            case 2:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize3.svg`),
                prizeObject.title = this.$t('third_place')
              prizeObject.color = 'gold'
              break
            case 3:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize4.svg`),
                prizeObject.title = this.$t('fourth_place')
              prizeObject.color = 'gray-900'
              break
            case 4:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('fifth_place')
              prizeObject.color = 'gray-600'
              break
            case 5:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('sixth_place')
              prizeObject.color = 'gray-600'
              break
            case 6:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('seventh_place')
              prizeObject.color = 'gray-600'
              break
            case 7:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('eitth_place')
              prizeObject.color = 'gray-600'
              break
            case 8:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('nineth_place')
              prizeObject.color = 'gray-600'
              break
            case 9:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('tenth_place')
              prizeObject.color = 'gray-600'
              break
          }
          prizes.push(prizeObject)
        })
        this.prizes = prizes
      }
    },
    async getCurrentContestant() {
      // this['logoLoader/set'](true)
      try {
        let response = await service.post('/trading-competition/leaderboard', { username: this.User.username, competition_id: this.competition.id, page: 1, recordsPerPage: 10 })
        if (response.data.count !== 0) {
          this.currentUserData = response.data.data[0]
          this.selectedContestant = response.data.data[0]
          this.userIsContestant = true
        } else {
          this.selectedContestant = this.contestants[0]
          this.userIsContestant = false
        }
      } catch (error) {
        this.userIsContestant = false
        this.selectedContestant = this.contestants[0]
      }
    },
    async getContestants(first) {
      // this['logoLoader/set'](true)
      try {
        let response = await service.post('/trading-competition/leaderboard', { username: this.nameSearch, page: this.page, recordsPerPage: 10, competition_id: this.competition.id })
        if (response.data) {
          if (first && this.userIsContestant) {
            this.selectedContestant = response.data.data[0]
          } else {
            this.contestants = response.data.data
            this.selectedContestant = response.data.data[0]
          }
          // Add current leader from the first contestant
          if (this.statisticsCards[3].statisticValueDate === "") this.statisticsCards[3].statisticValueDate = this.selectedContestant.username

          this.records = response.data.count
        }
        // this['logoLoader/set'](false)
      } catch (error) {
        // this['logoLoader/set'](false)
        console.log(error)
      }
    },
    nameChange(name) {
      this.nameSearch = name;
      this.page = 1
      this.getContestants(false)
    },
    pageChange(page) {
      this.page = page
      this.getContestants(false)
    },
    selectContestant(contestant) {
      this.selectedContestant = contestant
    },
    togglePrizeDropdown(mobile) {
      if (mobile) {
        this.openPrizesMobile = !this.openPrizesMobile
      } else this.openPrizes = !this.openPrizes
    },
    closeDropdown(event) {
      const dropdownElement = this.$refs.dropdown;
      const dropdownElementMobile = this.$refs.dropdownMobile
      if (!dropdownElement || !dropdownElement.contains(event.target)) {
        this.openPrizes = false;
      }
      if (!dropdownElementMobile || !dropdownElementMobile.contains(event.target)) {
        this.openPrizesMobile = false
      }
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth < 434
    },
    ...mapActions(['logoLoader/set']),
  }


}
</script>
